"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _react = _interopRequireDefault(require("react"));

var _meridianReactInputMask = _interopRequireDefault(require("@amzn/meridian-react-input-mask"));

/**
 * This class can be used to instantiate an input mask object that can be passed
 * to the `mask` prop of the `Input` component. For example a basic US phone
 * number mask can be created like this:
 *
 * ```
 * import Input from "@amzn/meridian/input"
 * import InputMask from "@amzn/meridian/input/mask"
 *
 * const phoneMask = new InputMask("(###)###-####")
 * <Input mask={phoneMask} />
 * ```
 */
var InputMask = /*#__PURE__*/function () {
  function InputMask(mask) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    (0, _classCallCheck2["default"])(this, InputMask);
    var _options$placeholderC = options.placeholderChar,
        placeholderChar = _options$placeholderC === void 0 ? String.fromCharCode(8199) : _options$placeholderC,
        _options$formatChars = options.formatChars,
        formatChars = _options$formatChars === void 0 ? {
      "#": "[0-9]",
      x: "[A-Za-z]",
      "*": "[A-Za-z0-9]"
    } : _options$formatChars,
        _options$alwaysShow = options.alwaysShow,
        alwaysShow = _options$alwaysShow === void 0 ? false : _options$alwaysShow,
        _options$beforeMasked = options.beforeMaskedValueChange,
        beforeMaskedValueChange = _options$beforeMasked === void 0 ? undefined : _options$beforeMasked;
    this.alwaysShow = alwaysShow;
    this.mask = mask;
    this.placeholderChar = placeholderChar;
    this.formatChars = formatChars;
    this.beforeMaskedValueChange = beforeMaskedValueChange;
  }

  (0, _createClass2["default"])(InputMask, [{
    key: "getElement",
    value: function getElement(props) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _options$alwaysShow2 = options.alwaysShow,
          alwaysShow = _options$alwaysShow2 === void 0 ? this.alwaysShow : _options$alwaysShow2,
          _options$placeholderC2 = options.placeholderChar,
          placeholderChar = _options$placeholderC2 === void 0 ? this.placeholderChar : _options$placeholderC2,
          _options$formatChars2 = options.formatChars,
          formatChars = _options$formatChars2 === void 0 ? this.formatChars : _options$formatChars2,
          _options$beforeMasked2 = options.beforeMaskedValueChange,
          beforeMaskedValueChange = _options$beforeMasked2 === void 0 ? this.beforeMaskedValueChange : _options$beforeMasked2;
      return /*#__PURE__*/_react["default"].createElement(_meridianReactInputMask["default"], (0, _extends2["default"])({}, props, {
        alwaysShowMask: alwaysShow,
        maskChar: placeholderChar,
        formatChars: formatChars,
        beforeMaskedValueChange: beforeMaskedValueChange,
        mask: this.mask
      }));
    }
  }]);
  return InputMask;
}();

var _default = InputMask;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@amzn/meridian/input/mask.js
// module id = 880
// module chunks = 0